// extracted by mini-css-extract-plugin
export default {"note":"StartedPick_note__bJ0RF","badge":"StartedPick_badge__HlRcD","live":"StartedPick_live__-YbA6"};